interface Options {
  shouldUseInsuranceMemberPrice?: boolean;
  luxPlusEnabled?: boolean;
}

function formatPointsEarnCalculationRequest(
  calculationRequest: App.LuxLoyaltyPointsEarnCalculationRequest,
  options?: Options,
): App.LuxLoyaltyPointsEarnCalculationRequest {
  switch (calculationRequest.luxLoyaltyProductType) {
    case 'insurance': {
      const { memberPrice, price } = calculationRequest
      const { shouldUseInsuranceMemberPrice } = options ?? {}

      const calculationPrice = shouldUseInsuranceMemberPrice && !!memberPrice ? memberPrice : price
      return {
        price: calculationPrice,
        luxLoyaltyProductType: calculationRequest.luxLoyaltyProductType,
        mx: calculationRequest.mx,
        itemId: calculationRequest.itemId,
      }
    }
    case 'hotel_flash':
    case 'hotel_lpc': {
      const { memberPrice, price } = calculationRequest
      const { luxPlusEnabled } = options ?? {}

      const calculationPrice = luxPlusEnabled && !!memberPrice ? memberPrice : price

      return {
        price: calculationPrice,
        luxLoyaltyProductType: calculationRequest.luxLoyaltyProductType,
        mx: calculationRequest.mx,
        offerId: calculationRequest.offerId,
        packageId: calculationRequest.packageId,
        itemId: calculationRequest.itemId,
      }
    }
    default: {
      const { memberPrice, price } = calculationRequest
      const { luxPlusEnabled } = options ?? {}

      const calculationPrice = luxPlusEnabled && !!memberPrice ? memberPrice : price
      return {
        price: calculationPrice,
        luxLoyaltyProductType: calculationRequest.luxLoyaltyProductType,
        mx: calculationRequest.mx,
        itemId: calculationRequest.itemId,
      }
    }
  }
}

export default formatPointsEarnCalculationRequest
